import { faArrowRight, faBookOpen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DOCS_REDIRECTS } from '@journeyapps/package-types';
import * as React from 'react';
import { parsePath } from 'react-router';
import { CardWidget } from './CardWidget';
import { findDocsPage, normalizePermalink } from '../pages/docs/shared/docs';

export interface DocsReferenceWidgetProps {
  href: string;
  variant?: 'related' | 'next';
}

export const DocsReferenceWidget: React.FC<DocsReferenceWidgetProps> = ({ href, variant = 'related' }) => {
  const { pathname = '', search = '', hash = '' } = parsePath(href);
  const permalink = normalizePermalink(pathname);
  const destination = DOCS_REDIRECTS[permalink] ?? permalink;
  const page = findDocsPage(destination);
  return (
    <CardWidget
      compact
      href={page ? `${destination}${search}${hash}` : href}
      title={page?.frontmatter.title ?? href}
      description={page?.frontmatter.description}
      metadata={variant === 'next' ? 'Next step' : 'Related guide'}
      icon={<FontAwesomeIcon icon={variant === 'next' ? faArrowRight : faBookOpen} aria-hidden="true" />}
    />
  );
};
